import { Route, createPageRoute, AppId } from '@lumapps/router';

export const userManagementRoute: Route = createPageRoute({
    slug: 'users-management',
    appId: AppId.backOffice,
});
